import React, { useEffect, useState } from 'react'
import { Box, Icon, Tooltip } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'

const RespFloatActBtn = ({
  handleFloatAddQuestion,
  handleFloatAddSection,
  handleSectMove,
  formStructure,
  activeId,
  activeType,
}) => {
  const [quesIndex, setQuesIndex] = useState('')
  const [sectIndex, setSectIndex] = useState('')

  useEffect(() => {
    let form = JSON.parse(JSON.stringify(formStructure))
    if (activeType === 'question') {
      form.forEach((i, index) =>
        i.findIndex((i) => i === activeId) !== -1
          ? (setQuesIndex(i.findIndex((i) => i === activeId)), setSectIndex(index))
          : null
      )
    } else if (activeType === 'section') {
      setQuesIndex(undefined)
      setSectIndex(activeId)
    }
  }, [activeId])

  let form = JSON.parse(JSON.stringify(formStructure))

  const hoverProp = () => {
    return {
      width: '45px',
      minWidth: '0px',
      height: '45px',
      borderRadius: '50%',
    }
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '50px',
      }}
      px={{ xs: 3, sm: 7 }}
      position="fixed"
      bottom={0}
    >
      <Box
        sx={{
          backgroundColor: 'white.main',
          boxShadow: '0px 0px 10px lightgray',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        }}
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        py={1}
        gap={3}
      >
        {activeType === 'section' && sectIndex !== 0 ? (
          <AdxButton
            variant={'ghost'}
            sx={{ ...hoverProp() }}
            onClick={() => handleSectMove('up', sectIndex)}
          >
            <Tooltip title="Move section up" placement="top">
              <Icon>keyboard_arrow_up_icon</Icon>
            </Tooltip>
          </AdxButton>
        ) : null}
        {activeType === 'section' && formStructure.length !== sectIndex + 1 ? (
          <AdxButton
            variant={'ghost'}
            sx={{ ...hoverProp() }}
            onClick={() => handleSectMove('down', sectIndex)}
          >
            <Tooltip title="Move section down" placement="top">
              <Icon>keyboard_arrow_down_icon</Icon>
            </Tooltip>
          </AdxButton>
        ) : null}
        <AdxButton
          variant={'ghost'}
          sx={{ ...hoverProp() }}
          onClick={() => handleFloatAddSection(sectIndex, quesIndex)}
        >
          <Tooltip title="Add section" placement="top">
            <Icon>splitscreen_outlined_icon</Icon>
          </Tooltip>
        </AdxButton>
        <AdxButton
          variant={'ghost'}
          sx={{ ...hoverProp() }}
          onClick={() => handleFloatAddQuestion(sectIndex, quesIndex)}
        >
          <Tooltip title="Add question" placement="top">
            <Icon>add_comment_icon</Icon>
          </Tooltip>
        </AdxButton>
      </Box>
    </Box>
  )
}

export default RespFloatActBtn
